import { AxiosInstance } from "axios";

import {
  AttendanceClient,
  BookingsClient,
  ContentClient,
  DashboardClient,
  DocumentsClient,
  EducatorsClient,
  FeeInformationFlyerClient,
  HolidayClubClient,
  KeyDatesClient,
  OperationalInformationClient,
  PartnershipRequestClient,
  SchoolContactClient,
  ServiceClient,
} from "./PartnerPortalGatewayApi";
import { config } from "../config";
import axiosClient from "../utils/axiosFactory";

class ApiClient {
  private client: AxiosInstance;

  // Individual API clients
  public attendance: AttendanceClient;
  public bookings: BookingsClient;
  public content: ContentClient;
  public dashboard: DashboardClient;
  public documents: DocumentsClient;
  public educators: EducatorsClient;
  public feeInformationFlyer: FeeInformationFlyerClient;
  public holidayClub: HolidayClubClient;
  public keyDates: KeyDatesClient;
  public operationalInformation: OperationalInformationClient;
  public partnershipRequest: PartnershipRequestClient;
  public schoolContact: SchoolContactClient;
  public service: ServiceClient;

  constructor(baseURL: string = config.apiBaseUrl) {
    // Use the axiosFactory for enhanced features (retry, logging, etc.)
    this.client = axiosClient();
    this.client.defaults.baseURL = baseURL;
    this.client.defaults.timeout = 120000; // 120 seconds timeout

    // Initialize all the API clients with the configured axios instance
    this.attendance = new AttendanceClient(baseURL, this.client);
    this.bookings = new BookingsClient(baseURL, this.client);
    this.content = new ContentClient(baseURL, this.client);
    this.dashboard = new DashboardClient(baseURL, this.client);
    this.documents = new DocumentsClient(baseURL, this.client);
    this.educators = new EducatorsClient(baseURL, this.client);
    this.feeInformationFlyer = new FeeInformationFlyerClient(baseURL, this.client);
    this.holidayClub = new HolidayClubClient(baseURL, this.client);
    this.keyDates = new KeyDatesClient(baseURL, this.client);
    this.operationalInformation = new OperationalInformationClient(baseURL, this.client);
    this.partnershipRequest = new PartnershipRequestClient(baseURL, this.client);
    this.schoolContact = new SchoolContactClient(baseURL, this.client);
    this.service = new ServiceClient(baseURL, this.client);
  }
}

export const apiClient = new ApiClient();
